import { Component, OnInit } from '@angular/core';
import {MainMenuService} from '../../main-menu.service';
import {MainMenuItem} from '../../main-menu-item.model';

@Component({
  selector: 'app-menu-items',
  templateUrl: './menu-items-setup.component.html',
  styleUrls: ['./menu-items-setup.component.scss'],
  providers: [MainMenuService]
})
export class MenuItemsComponent implements OnInit {
  mainMenuItems: MainMenuItem[];

  constructor(public mainMenuService: MainMenuService) { }

  getMainMenuItems(): void {
    this.mainMenuService.getMainMenuItems().then(mainMenuItems => this.mainMenuItems = mainMenuItems);
  }

  ngOnInit(): void {
    this.getMainMenuItems();
  }

  toggle(event: Event, item: any, el: any) {
    event.preventDefault();

    const items: any[] = el.mainMenuItems;

    if (item.active) {
      item.active = false;
    } else {
      for (let i = 0; i < items.length; i++) {
        items[i].active = false;
      }
      item.active = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Dashboard/menus/main-menu/sidebar/menu-items/menu-items-setup.component.ts